import { render, staticRenderFns } from "./ChangeModal.vue?vue&type=template&id=71975419"
import script from "./ChangeModal.vue?vue&type=script&lang=js"
export * from "./ChangeModal.vue?vue&type=script&lang=js"
import style0 from "./ChangeModal.vue?vue&type=style&index=0&id=71975419&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports